
/* eslint-disable @typescript-eslint/no-shadow */
export namespace EmailStatus {
  export enum EmailStatus {
    QUEUED = "QUEUED",
    SENT = "SENT",
    DELIVERED = "DELIVERED",
    VIEWED = "VIEWED",
    UNSENT = "UNSENT",
    BOUNCED = "BOUNCED",
    STOPPED = "STOPPED",
    COMPLAINT = "COMPLAINT",
  }

  export interface EmailStatusDTO {
    case: string;
  }

  export const fromDTO = (dto: EmailStatusDTO): EmailStatus => {
    if (dto === undefined || dto === null) {
      throw new InvalidEmailStatusError(
        `Invalid DTO ${dto} provided for EmailStatus.EmailStatus`
      );
    }
    switch (dto.case) {
      case "QUEUED":
        return EmailStatus.QUEUED;
      case "SENT":
        return EmailStatus.SENT;
      case "DELIVERED":
        return EmailStatus.DELIVERED;
      case "VIEWED":
        return EmailStatus.VIEWED;
      case "UNSENT":
        return EmailStatus.UNSENT;
      case "BOUNCED":
        return EmailStatus.BOUNCED;
      case "STOPPED":
        return EmailStatus.STOPPED;
      case "COMPLAINT":
        return EmailStatus.COMPLAINT;
      default:
        throw new InvalidEmailStatusError(
          `Case ${dto.case} is not valid case of EmailStatus.EmailStatus`
        );
    }
  };

  export const toDTO = (emailStatus: EmailStatus): EmailStatusDTO => {
    const enumDTO = {
      case: EmailStatus[emailStatus],
    };
    return enumDTO;
  };
}

export class InvalidEmailStatusError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidEmailStatusError";
  }
}
export class InvalidEmailStatusQueuedError extends InvalidEmailStatusError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidEmailStatusQueuedError";
  }
}

export class InvalidEmailStatusSentError extends InvalidEmailStatusError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidEmailStatusSentError";
  }
}

export class InvalidEmailStatusDeliveredError extends InvalidEmailStatusError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidEmailStatusDeliveredError";
  }
}

export class InvalidEmailStatusViewedError extends InvalidEmailStatusError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidEmailStatusViewedError";
  }
}

export class InvalidEmailStatusUnsentError extends InvalidEmailStatusError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidEmailStatusUnsentError";
  }
}

export class InvalidEmailStatusBouncedError extends InvalidEmailStatusError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidEmailStatusBouncedError";
  }
}

export class InvalidEmailStatusStoppedError extends InvalidEmailStatusError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidEmailStatusStoppedError";
  }
}

export class InvalidEmailStatusComplaintError extends InvalidEmailStatusError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidEmailStatusComplaintError";
  }
}
